<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">Mensajes en estado: {{ estado }}</p>
      <button class="delete" @click="$emit('cerrar')"></button>
    </header>

    <section class="modal-card-body">
      <p class="subtitle is-6">Total: {{ mensajes.length }} mensaje(s)</p>

      <table class="table is-fullwidth is-bordered is-striped is-small">
        <thead>
          <tr>
            <th>Teléfono</th>
            <th>Mensaje</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="m in mensajes" :key="m.telefono + m.mensaje">
            <td>{{ m.telefono }}</td>
            <td>{{ m.mensaje }}</td>
          </tr>
        </tbody>
      </table>
    </section>

    <footer class="modal-card-foot is-justify-content-flex-end">
      <b-button type="is-link" size="is-small" @click="descargarCSV">
        Descargar CSV
      </b-button>
    </footer>
  </div>
</template>

<script>
export default {
  props: ["mensajes", "estado"],
  methods: {
    descargarCSV() {
      const encabezado = "telefono,mensaje\n";
      const cuerpo = this.mensajes
        .map((m) => `"${m.telefono}","${m.mensaje.replace(/"/g, '""')}"`)
        .join("\n");

      const blob = new Blob([encabezado + cuerpo], {
        type: "text/csv;charset=utf-8;",
      });

      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `mensajes_${this.estado}.csv`;
      a.click();
      URL.revokeObjectURL(url);
    },
  },
};
</script>



